import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export enum CompanyGovernmentAllocationEntryStatus {
  created = 'created',
  awaiting_management_review = 'awaiting_management_review',
  completed = 'completed',
}

export const companyGovernmentAllocationEntryStatusOptions = [
  { value: CompanyGovernmentAllocationEntryStatus.created, label: 'Criado' },
  { value: CompanyGovernmentAllocationEntryStatus.awaiting_management_review, label: 'Aguardando revisão' },
  { value: CompanyGovernmentAllocationEntryStatus.completed, label: 'Concluído' },
]

export const companyGovernmentAllocationEntryStatusStrategy = optionsToStrategy(
  companyGovernmentAllocationEntryStatusOptions,
)
